// extracted by mini-css-extract-plugin
export default {"imageContainer":"Kca-z","summaryPar":"Lca-z","ratingCategories":"Mca-z","reviewerInfo":"Nca-z","reviewTypes":"Oca-z","expanded":"Pca-z"};